export class Controller {

    /** @ngInject */
    constructor($http, $location, $state) {
        this.$http = $http;
        this.$location = $location;
        this.$state = $state;
    }

    $onInit() {
        this.$http
            .get('app/rest/account', {ignoreAuthModule: true})
            .then(() => this.$location.href(decodeURI(this.$state.params.continue)))
            .catch(() => this.$state.go('public.login', this.$state.params));
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/public/saaspass-connect-login/saaspass-connect-login.controller.js